import { Stack, Typography } from '@mui/material';
import React from 'react';
import { renderPriceValue } from '@/utils/priceConvert';
import { useAppSelector } from '@/utils/hook';
import { BottomContainer } from '../BottomContainer';
import { max } from 'lodash';
import { useDispatch } from 'react-redux';
import { setTotalFare } from '@/slices/selectedFlight/slices/selectedFlightSlice';

interface AddonsBottomPriceProps {
  title: string;
  isLoading?: boolean;
  onBtnClick?: () => void;
}

const AddonsBottomPrice: React.FC<AddonsBottomPriceProps> = ({
  title,
  onBtnClick,
  isLoading,
}) => {
  const dispatch = useDispatch();
  const { totalFare: cachedTotalFare } = useAppSelector((state) => state.selectedFlight);
  const selectedDepartBaggage = useAppSelector(
    (state) => state.baggage.selectedBaggages.depart,
  );
  const selectedReturnBaggage = useAppSelector(
    (state) => state.baggage.selectedBaggages.return,
  );
  const totalDepartBaggages = selectedDepartBaggage
    .map((sb) => sb.baggage.price)
    .filter((sbp) => sbp > 0);
  const totalReturnBaggages = selectedReturnBaggage
    .map((sb) => sb.baggage.price)
    .filter((sbp) => sbp > 0);
  const totalPriceDepart = totalDepartBaggages
    .reduce((curValue: number, nextValue: number) => curValue + nextValue, 0);
  const totalPriceReturn = totalReturnBaggages
    .reduce((curValue: number, nextValue: number) => curValue + nextValue, 0);

  const maxBaggages = max([totalDepartBaggages.length, totalReturnBaggages.length]) || 0;
  const totalPrice = Number(totalPriceDepart) + Number(totalPriceReturn);
  if (totalPrice && cachedTotalFare !== totalPrice) {
    dispatch(setTotalFare(totalPrice));
  }

  return (
    <BottomContainer
      isLoading={isLoading || false}
      handleNextPage={onBtnClick}
    >
      <Stack>
        <Typography
          variant="body2"
          color="#000000"
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 'bold' }}
          color="#1A1A1A"
        >
          {`${totalPrice > 0 ? '+' : ''}${renderPriceValue(
            totalPrice,
          )}${maxBaggages > 0 ? `/${maxBaggages} người` : ''}`}

        </Typography>
      </Stack>
    </BottomContainer>
  );
};

export default AddonsBottomPrice;
